export const ADMIN_STATUS_OPTIONS = [
	{ value: 'open', label: 'A responder' },
	{ value: 'closed', label: 'Respondidas' },
] as const;
